import type { ButtonHTMLAttributes, ReactNode } from "react";

import styles from "./Chip.module.css";

export interface ChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "aria-pressed"> {
  /** Active filter: ink background, announced as pressed. */
  active?: boolean;
  icon?: ReactNode;
  count?: number;
}

export function Chip({ active = false, icon, count, className, children, ...rest }: ChipProps) {
  return (
    <button
      type="button"
      aria-pressed={active}
      className={[styles.chip, active && styles.active, className].filter(Boolean).join(" ")}
      {...rest}
    >
      {icon}
      <span>{children}</span>
      {count !== undefined && <span className={styles.count}>{count}</span>}
    </button>
  );
}
